<div class="items-center justify-between lg:flex">
  <h2 class="mb-3 text-xl font-bold md:mb-0">Transaction History</h2>
  <!-- need date filter -->
  <!-- <div class="relative w-full md:w-80">
    <input
      type="text"
      class="w-full rounded-md border border-primary-main p-2 placeholder:font-medium placeholder:text-primary-dark focus:border focus:border-primary-md-dark focus:outline-none focus:ring-1 focus:ring-primary-md-dark"
      placeholder="Dari Tanggal - Sampai Tanggal" />
    <fa-icon
      class="absolute top-1/2 right-2 -translate-y-1/2 text-primary-md-dark"
      [icon]="faCalenderDays">
    </fa-icon>
  </div> -->
</div>

<div class="hp-list mt-5 space-y-3">
  <div
    class="hp-item divide-y divide-gray-200 rounded-md border shadow-md"
    *ngFor="let activity of activities; let i = index"
    (click)="toggle(i)">
    <div class="hp-content flex cursor-pointer items-center gap-3 p-3">
      <div class="icon-wrapper" [ngSwitch]="activity.activity_type_name">
        <fa-icon
          class="icon"
          *ngSwitchCase="'Checkout'"
          [icon]="faShoppingCart"></fa-icon>
        <fa-icon
          class="icon"
          *ngSwitchCase="'Withdraw'"
          [icon]="faMinusSquare"></fa-icon>
        <fa-icon class="icon" *ngSwitchDefault [icon]="faPlusSquare"></fa-icon>
      </div>
      <div class="info flex-1">
        <div class="title">{{ activity.activity_type_name }}</div>
        <!-- <div class="subtitle text-max">{{activity.note}}</div> -->
      </div>
      <div class="amount flex-1" [ngSwitch]="activity.activity_type_name">
        <div class="minus" *ngSwitchCase="'Checkout'">
          - {{ activity.activityable.grand_total | fcCurrency }}
        </div>
        <div class="minus" *ngSwitchCase="'Withdraw'">
          - {{ activity.activityable.amount | fcCurrency }}
        </div>
        <div class="plus" *ngSwitchCase="'Top Up'">
          {{ activity.activityable.amount | fcCurrency }}
        </div>
        <div class="plus" *ngSwitchCase="'Adjustment'">
          {{ activity.activityable.amount | fcCurrency }}
        </div>
        <div class="plus" *ngSwitchCase="'Order Cancelled'">
          {{ activity.activityable.total | fcCurrency }}
        </div>
      </div>
      <div class="chevron">
        <fa-icon
          [icon]="activity.toggle ? faChevronDown : faChevronRight"></fa-icon>
      </div>
    </div>
    <div
      class="hp-detail grid gap-3 p-3 md:flex"
      *ngIf="activity.toggle"
      [ngSwitch]="activity.activity_type_name">
      <ng-container *ngSwitchCase="'Adjustment'">
        <div class="detail-item flex-1">
          <div class="label text-primary-darkest/50">Tanggal Adjustment</div>
          <div class="value">
            {{ activity.activityable.created_at | date: 'dd MMM yyyy, HH:mm' }}
          </div>
        </div>
        <div class="detail-item flex-1">
          <div class="label text-primary-darkest/50">Adjusted By</div>
          <div class="value">{{ activity.activityable.created_by_name }}</div>
        </div>
        <div class="detail-item flex-1">
          <div class="label text-primary-darkest/50">Note</div>
          <div class="value">{{ activity.activityable.note }}</div>
        </div>
      </ng-container>
      <ng-container *ngSwitchCase="'Order Cancelled'">
        <div class="detail-item flex-1">
          <div class="label text-primary-darkest/50">Tanggal Pembatalan</div>
          <div class="value">
            {{ activity.activityable.cancel_date | date: 'dd MMM yyyy, HH:mm' }}
          </div>
        </div>
        <div class="detail-item flex-1">
          <div class="label text-primary-darkest/50">No. Order</div>
          <div class="value">{{ activity.activityable.id }}</div>
        </div>
        <div class="detail-item flex-1">
          <div class="label text-primary-darkest/50">Belanja di</div>
          <div class="value">{{ activity.activityable.shop_name }}</div>
        </div>
        <div class="detail-item flex-1">
          <div class="label text-primary-darkest/50">Cancellation Note</div>
          <div class="value">{{ activity.activityable.cancel_note }}</div>
        </div>
      </ng-container>
      <ng-container *ngSwitchCase="'Checkout'">
        <div class="detail-item flex-1">
          <div class="label text-primary-darkest/50">Order Date</div>
          <div class="value">
            {{
              activity.activityable.transaction_time
                | date: 'dd MMM yyyy, HH:mm'
            }}
          </div>
        </div>
        <div class="detail-item flex-1">
          <div class="label text-primary-darkest/50">No. Order</div>
          <div class="value">{{ activity.activityable.id }}</div>
        </div>
      </ng-container>
      <ng-container *ngSwitchCase="'Withdraw'">
        <div class="detail-item flex-1">
          <div class="label text-primary-darkest/50">Order Date</div>
          <div class="value">
            {{ activity.activityable.created_at | date: 'dd MMM yyyy, HH:mm' }}
          </div>
        </div>
        <div class="detail-item flex-1">
          <div class="label text-primary-darkest/50">Ditransfer ke</div>
          <div class="value">
            {{ activity.activityable.to_bank_account_account_info }}
          </div>
        </div>
        <div class="detail-item flex-1">
          <div class="label text-primary-darkest/50">Status</div>
          <div class="value">{{ activity.activityable.status_name }}</div>
        </div>
        <div
          class="detail-item flex-1"
          *ngIf="activity.activityable.status == 1">
          <div class="label text-primary-darkest/50">Tanggal Konfirmasi</div>
          <div class="value">
            {{
              activity.activityable.confirmed_at | date: 'dd MMM yyyy, HH:mm'
            }}
          </div>
        </div>
      </ng-container>
      <ng-container *ngSwitchCase="'Top Up'">
        <div class="detail-item flex-1">
          <div class="label text-primary-darkest/50">Order Date</div>
          <div class="value">
            {{ activity.activityable.created_at | date: 'dd MMM yyyy, HH:mm' }}
          </div>
        </div>
        <div class="detail-item flex-1">
          <div class="label text-primary-darkest/50">Payment Method</div>
          <div class="value">{{ activity.activityable.method_name }}</div>
        </div>
        <div class="detail-item flex-1">
          <div class="label text-primary-darkest/50">Status</div>
          <div class="value">{{ activity.activityable.status_name }}</div>
        </div>
      </ng-container>
    </div>
  </div>
  <div class="load-more text-center" *ngIf="!hideLoadMore">
    <button
      class="test rounded py-1 px-3 text-primary-md-dark hover:bg-gray-50"
      [ngClass]="{ 'opacity-50': loading }"
      (click)="loadActivity()"
      [disabled]="loading">
      <span class="btn-label"
        >Show more <fa-icon class="ml-1" [icon]="faChevronDown"></fa-icon
      ></span>
      <fa-icon
        class="load-icon"
        *ngIf="loading"
        [icon]="faSpinner"
        [spin]="true"></fa-icon>
    </button>
  </div>
</div>
